module.exports = __webpack_public_path__ + "img/myposition_cf_로베르트 레반도프스키.135b16f6.png";